import { Document, Page, pdfjs, Viewer } from 'react-pdf';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlus,
    faMinus,
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import useDebounce from '../../../../shared/helpers/useDebounce';




const ModalVisualizadorPdf = ({urlLink, isOpen, setIsOpen, title, instituicaoRx, onClosed}) => {
    const [numPages, setNumPages] = useState(null);
    const modalRef = useRef(null)
    const [zoom, setZoom] = useState(1)
    const [currentPage, setCurrentPage] = useState(1);
    const pageRefs = useRef([]);
    const documentRef = useRef(null)
    const [scrollRunning, setScrollRunning] = useState(false)
    const scrollRunningTimeoutRef = useRef(null)
    const [inputNumPage, setInputNumPage] = useState(null)

    const onChangeInputPage = (value) => {
        if (/^\d*$/.test(value) || value < 0 || value > numPages) {
            changePage(value)
        }
    }

    const  [debouncedChageInputPage, clearOnChangePage] = useDebounce(onChangeInputPage, 500)




    useEffect(() => {
        setInputNumPage(currentPage)
    }, [currentPage])


    useEffect(() => {
        if(zoom !== 1) setZoom(1)
    }, [])

    const handleZoomIn =  () => {
       setZoom(zoom + 0.5)
    }

    const handleZoomOut = () => {
        setZoom(Math.max(0.5, zoom - 0.5));
    }

    const [modalWidth, setModalWidth] = useState(0);


    useEffect(() => {
        const updateModalSize = () => {
            if (modalRef.current && zoom === 1) {
                const modalBody = modalRef.current.querySelector('.modal-body');
                const width = modalBody.offsetWidth;
                setModalWidth(width - 16)
            }
        };

        updateModalSize();

        window.addEventListener('resize', updateModalSize);

        return () => {
            window.removeEventListener('resize', updateModalSize);
        };
    }, [modalRef.current, zoom]);

    const zoomButtonStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        backgroundColor: 'rgba(0,0,0,.5)',
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        width: '28px',
        height: '28px'
    };



    const changePage = (pageNumber) => {
        if (!isNaN(pageNumber) && pageNumber > 0 && pageNumber <= numPages) {
            setCurrentPage(pageNumber);
            pageRefs.current[pageNumber - 1]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };


    useEffect(() => {
        return () => {
            clearOnChangePage()
            if(scrollRunningTimeoutRef.current){
                clearTimeout(scrollRunningTimeoutRef.current)
            }
        }
    }, []);



    useEffect(() => {
        const handleScroll = () => {
            if (!pageRefs.current.length) return;

            const modalBody = modalRef.current?.querySelector('.modal-body');
            if (!modalBody) return;

            let closestPage = 1;
            let minDistance = Infinity;

            pageRefs.current.forEach((page, index) => {
                if (!page) return;

                const rect = page.getBoundingClientRect();
                const distance = Math.abs(rect.top - modalBody.getBoundingClientRect().top);

                if (distance < minDistance) {
                    minDistance = distance;
                    closestPage = index + 1;
                }
            });

            setCurrentPage(closestPage);
        };

        const modalBody = modalRef.current?.querySelector('.modal-body');
        if (modalBody) {
            modalBody.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (modalBody) modalBody.removeEventListener('scroll', handleScroll);
        };
    }, [numPages]);

    useEffect(() => {
        debouncedChageInputPage(inputNumPage)
    }, [inputNumPage])

    return (
        <Modal
            onClosed={() => {
                if(onClosed && typeof onClosed === 'function')
                    onClosed();
            }}
            innerRef={modalRef}
            modalClassName='tema-pergamum'
            isOpen={isOpen}
            toggle={() => setIsOpen(!isOpen)}
            size={zoom < 1 ? 'md' : zoom > 1 ? 'xl' : 'lg'}
            scrollable
        >
            <ModalHeader
                style={{padding:"1rem 1rem 10px 1rem"}}
                className="b-solid-bottom b-branco cortxt negrito"
                toggle={() => setIsOpen(!isOpen)}
                close={<button
                    className="close s20 branco float-right mr-1 rad5"
                    style={{ fontWeight: 'normal' }}
                    onClick={() => setIsOpen(false)}
                >
                    <FontAwesomeIcon icon="times" className="fa-fw" />
                </button>}
            >
                <div className="f700 branco s20 ">
                    {title}
                </div>
            </ModalHeader>
            <ModalBody style={{ padding: 0 }}>
                <Document
                    inputRef={documentRef}
                    file={urlLink}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    className="pdf-container"
                >
                    {numPages &&
                        Array.from({ length: numPages }, (_, i) => i + 1).map((page) => (
                            <Page
                                key={page}
                                pageNumber={page}
                                scale={zoom}
                                width={modalWidth}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                                inputRef={(el) => (pageRefs.current[page - 1] = el)}
                            />
                        ))}
                </Document>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center align-items-center position-relative">
                <div className='d-flex flex-column justify-content-center align-items-center'>
                    <span style={{ fontSize: '14px', color: 'rgba(0,0,0,.4)' }}>
                        <span className="s14 font-weight-bolder">Zoom:</span> {zoom === 1 ? 'normal' : `${zoom * 100}%`}
                    </span>
                        <div className="d-flex justify-content-center align-items-center" style={{ gap: '24px' }}>
                            <button
                                style={zoomButtonStyle}
                                onClick={handleZoomOut}>
                                <FontAwesomeIcon icon={faMinus} />
                            </button>
                            <button
                                style={zoomButtonStyle}
                                title={'zoom'}
                                onClick={handleZoomIn}>
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </div>
                </div>

                {
                    numPages && numPages > 0 ? (
                        <div className="d-flex justify-content-center flex-column align-items-center position-absolute"
                             style={{ right: '8px' }}>
                            <span style={{ fontSize: '14px', color: 'rgba(0,0,0,.4)' }}>
                                <span className="s14 font-weight-bolder">Páginas:</span>
                            </span>
                            <div className="d-flex justify-content-center align-items-center" style={{ gap: '8px' }}>
                                {
                                    currentPage > 1 ? (
                                        <button
                                            style={zoomButtonStyle}
                                            onClick={e => changePage(currentPage - 1)}>
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </button>
                                    ) : ''
                                }
                                <input
                                    className='border-0 text-center'
                                    style={{ width: '40px', color: 'rgba(0,0,0,.4)', backgroundColor: 'rgba(0,0,0,.1)'}}
                                    type="text"
                                    value={inputNumPage}
                                    onChange={(e) => {
                                        const {value} = e.target;
                                        if(/^\d*$/.test(value) || value < 0) {
                                            setInputNumPage(value)
                                        }
                                    }} />
                                <span>/</span>
                                <span className='ml-3' style={{ fontSize: '16px', color: 'rgba(0,0,0,.4)' }}>{numPages}</span>
                                {
                                    currentPage < numPages ? (
                                        <button
                                            style={zoomButtonStyle}
                                            title='next'
                                            onClick={e => changePage(currentPage + 1)}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </button>
                                    ) : ''
                                }
                            </div>
                        </div>
                    ) : ''
                }

            </ModalFooter>
        </Modal>
    );
}

const mapStateToProps = state => ({
    instituicaoRx: state.instituicao.data,
});

export default connect(mapStateToProps)(ModalVisualizadorPdf);
